import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import "./AddVendorAccount.scss";

const ValidationData = gql`
  query GetValidatedDataWithAccountIDAndType($accountId: ID, $typeOfData: String) {
    GetValidatedDataWithAccountIDAndType(AccountID: $accountId, Type_Of_Data: $typeOfData) {
      Unique_Id
      AccountID
      Aadhaar_Details
      Registration_Code
      Stored_Data
      createdAt
      updatedAt
    }
  }
`;
const ViewVendorFiles = ({ show, setShowModal, accountId, Type, Values, Remark }) => {
  console.log(Values);
  const { data } = useQuery(ValidationData, {
    variables: { accountId: accountId, typeOfData: Type },
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [storedDataObj, setStoredDataObj] = useState({});
  const FormData = useSelector((store) => store.FormFieldData);
  useEffect(() => {
    if (data && data.GetValidatedDataWithAccountIDAndType) {
      const storedDataString = data.GetValidatedDataWithAccountIDAndType?.Stored_Data;
      if (storedDataString) {
        try {
          const parsedData = JSON.parse(storedDataString);
          setStoredDataObj(parsedData);
        } catch (error) {
          console.error("Error parsing Stored_Data:", error);
        }
      }
    }
  }, [data]);

  const [open, setOpen] = useState(show);
  const Closeformfunction2 = () => {
    setShowModal();
    setOpen(false);
  };

  const submit = async () => {
    console.log("Remarks Submitted");
  };

  const renderDataContent = () => {
    if (Type === "verified") {
      return (
        <div className="Remarkdata">
          <p>{Remark["Verified_Remark"] || `Data Not Available`}</p>
        </div>
      );
    }

    if (Type === "Not_Intrested") {
      return (
        <div className="Remarkdata">
          <p>{Remark["Not_Intrested_Remark"] || `Data Not Available`}</p>
        </div>
      );
    }

    // if here data is comming as empty we should return  no reviews
    if (!storedDataObj || Object.keys(storedDataObj)?.length === 0) {
      return <p>No data available.</p>;
    }

    if ("pan_number" in storedDataObj) {
      return (
        <div className="showDetails">
          <h3>PAN Details:</h3>
          <p>
            <b>first Name:</b> {storedDataObj.first_name}
          </p>
          <p>
            <b>last Name:</b> {storedDataObj.last_name}
          </p>
          <p>
            <b>middle Name:</b> {storedDataObj.middle_name}
          </p>
          <p>
            <b>pan Aadhaar Seeding:</b> {storedDataObj.pan_aadhaar_seeding}
          </p>
          <p>
            <b>pan Holder:</b> {storedDataObj.pan_holder_title}
          </p>
          <p>
            <b>pan Last Updated:</b> {storedDataObj.pan_last_updated}
          </p>
          <p>
            <b>PAN Number:</b> {storedDataObj.pan_number}
          </p>
          <p>
            <b>Status:</b> {storedDataObj.pan_status}
          </p>
          <p>
            <b>Status Description:</b> {storedDataObj.pan_status_desc}
          </p>
        </div>
      );
    }

    if ("aadhaar_age" in storedDataObj) {
      return (
        <div className="showaadharDetails">
          <div>
            <img className="aadharImage" src={`data:image/png;base64,${storedDataObj?.aadhaar_photo}`} alt="Image" />
          </div>
          <div>
            <p>
              <b>Name:</b> {storedDataObj.aadhaar_name}
            </p>
            <p>
              <b>Gender:</b> {storedDataObj.aadhaar_gender}
            </p>
            <p>
              <b>DOD:</b>
              {storedDataObj.aadhaar_dob}
            </p>
            <p>
              <b>Age:</b>
              {storedDataObj.aadhaar_age}
            </p>
            <p>
              <b>Address:</b>
              {storedDataObj.aadhaar_address}
            </p>
            <p>
              <b>Country:</b>
              {storedDataObj.aadhaar_country}
            </p>
          </div>
        </div>
      );
    }
    if ("business_legal_name" in storedDataObj) {
      return (
        <div className="showaadharDetails">
          <div>
            <p>
              <b>Business Legal Name:</b> {storedDataObj.business_legal_name}
            </p>
            <p>
              <b>Business Trade Name:</b> {storedDataObj.business_trade_name}
            </p>
            <p>
              <b>Business State Jurisdiction:</b>
              {storedDataObj.business_state_jurisdiction}
            </p>
            <p>
              <b>Business State Jurisdiction Code:</b>
              {storedDataObj.business_state_jurisdiction_code}
            </p>
            <p>
              <b>Business Taxpayer Type:</b>
              {storedDataObj.business_taxpayer_type}
            </p>
            <p>
              <b>Business Gstin Status:</b>
              {storedDataObj.business_gstin_status}
            </p>
            <p>
              <b>Business Gstin Validity From:</b>
              {storedDataObj.business_gstin_validity_from}
            </p>
            <p>
              <b>Business Constitution Type:</b>
              {storedDataObj.business_constitution_type}
            </p>
            <p>
              <b>Business Address:</b>
              {`
              ${storedDataObj.business_address_primary_number},
              ${storedDataObj.business_address_primary_floor},
              ${storedDataObj.business_address_primary_building},
              ${storedDataObj.business_address_primary_street1},
              ${storedDataObj.business_address_primary_location},
              ${storedDataObj.business_address_primary_district},
              ${storedDataObj.business_address_primary_state},
              ${storedDataObj.business_address_primary_pincode}
`}
            </p>
          </div>
        </div>
      );
    }
    return <p>Unknown data format.</p>;
  };

  return (
    <Reactportal open={open} onClose={Closeformfunction2} TypeOfPortal={"Review Files"}>
      {/* Here we are rendering the aadhar details and pan details */}
      <div className="formContainer">{renderDataContent()}</div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        handleformclose={() => {
          Closeformfunction2();
          setOpen(false);
        }}
        Cancletype={"Ok"}
      />
    </Reactportal>
  );
};

export default ViewVendorFiles;
